import SystemCheckOutlineIcon from '@kcd/design-system/dist/icons/ic__system__check__outline.svg';
import SystemDownloadOutlineIcon from '@kcd/design-system/dist/icons/ic__system__download__outline.svg';

import CouponEmptyIcon from './ic__coupon-empty.svg';
import CouponRadioIcon from './ic__coupon-radio.svg';
import RedCoupon16x16Icon from './red_coupon_16x16.svg';

export {
  CouponEmptyIcon,
  CouponRadioIcon,
  RedCoupon16x16Icon,
  SystemCheckOutlineIcon,
  SystemDownloadOutlineIcon,
};
